import { useEffect, useRef, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getStatusChangeEventData,saveStatusChangeEventOption,getShowFlex, setPageSetting} from "../../actions";
import { StatusChangeEventComponent, DescriptionComponent, NextPrevComponent } from "../../components";
import { RootState } from "../../reducers";
import { ObjectUtils } from "../../utils";
import { StatusChangeEventModal } from "../../interfaces/formValidation";

export const StatusChangeEvent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputElement = useRef<HTMLInputElement[]>([]);
  const [sessionStatusChangeEvent, setsessionStatusChangeEvent] = useState<StatusChangeEventModal>({
    isSelected: false,
    errorMessage: "",
    statusChangeBenefitCombinationID: -1
  });
  const { statusChangeEvent } = useSelector((state: RootState) => state.statusChangeEvent);
  const contents = statusChangeEvent?.contentResource?.contents ? statusChangeEvent?.contentResource?.contents : {};
  const lblStatusChangeEventAcknowledge = ObjectUtils.extractLabelFromObject(contents, "lblStatusChangeEventAcknowledge");
  const lblStatusChangeEventSubTitle = ObjectUtils.extractLabelFromObject(contents, "lblStatusChangeEventSubTitle");
  const contentFooter = useSelector((state: RootState) => state.common.contentFooter);
  const footerContent = contentFooter?.contentResource?.contents;
  const btnCancel = ObjectUtils.extractLabelFromObject(footerContent || {}, "btnCancel");
  const lblBtnSubmit = ObjectUtils.extractLabelFromObject(footerContent, "btnSubmit");
  
  const handleValue = () => {
    setsessionStatusChangeEvent({
      ...sessionStatusChangeEvent,
      isSelected: !sessionStatusChangeEvent.isSelected
    });
  };

  const setStatusChangeEventOption = (statusChangeBenefitCombinationID: number) => {
    setsessionStatusChangeEvent({
      ...sessionStatusChangeEvent,
      statusChangeBenefitCombinationID: statusChangeBenefitCombinationID
    });
  };

  const handleSubmit = () => {
    dispatch(
      saveStatusChangeEventOption(sessionStatusChangeEvent?.statusChangeBenefitCombinationID, sessionStatusChangeEvent.isSelected,
        async () => {
          dispatch(await getShowFlex());
          navigate("/EnrollmentConfirmation");
          setPageSetting("WELCOME");
        },
        (_errorMessage: any) => {
          setsessionStatusChangeEvent({
            ...sessionStatusChangeEvent,
            errorMessage: _errorMessage
          });
          sessionStatusChangeEvent.errorMessage && inputElement.current[0].focus();
        }
      )
    );
  };

  useEffect(() => {
    async function fetchStatusChangeEventInfo() {
      if (!statusChangeEvent && !statusChangeEvent?.statusChangeEvent) {
        dispatch(await getStatusChangeEventData());
      }
    }
    fetchStatusChangeEventInfo();
    const statusChangeBenefitCombinationID = statusChangeEvent?.statusChangeEvent?.options.find((item: any) => item?.isSelected === true)?.statusChangeBenefitCombinationID || -1;
    setStatusChangeEventOption(statusChangeBenefitCombinationID);  

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusChangeEvent, dispatch]);

  const statusChangeEventList: any = [];
  statusChangeEvent?.statusChangeEvent?.options?.map((item: any, index: number) => {
    statusChangeEventList.push(
      <div key={`div-benefit-${index}-url-ID`}>
        <StatusChangeEventComponent optionsObject={item} optionsHeaderObject={statusChangeEvent?.statusChangeEvent?.header} setStatusChangeEventOption={setStatusChangeEventOption} />
      </div>
    );
  });

return (<>
    <div className={`healthcarecontent clearfix card`}>
      <div className="card-header">
        <div className="ml-titledescription d-flex justify-content-between">
          <div className="titlehelpicon">
            <DescriptionComponent level={2} hideextra={true} heading={lblStatusChangeEventSubTitle.display} />
          </div>
        </div>
      </div>
      <div> {statusChangeEventList?statusChangeEventList:null}</div>
      <div className="clearfix form-check confirmationcheck mb-3 mb-md-4">
        <input
          type="checkbox"
          key="confirmSelection"
          className="ms-1"
          id="confirmSelection"
          checked={sessionStatusChangeEvent?.isSelected}
          onChange={handleValue}
        />
        <label className="form-check-label warning" htmlFor="confirmSelection">
          {lblStatusChangeEventAcknowledge?.display}
        </label>
      </div>
    </div>
    {sessionStatusChangeEvent?.errorMessage !== "" && (
        <div className="pt-3 border-top">
          <div className="alert alert-danger" ref={(ref: HTMLInputElement) => (inputElement.current[0] = ref)} role="alert" dangerouslySetInnerHTML={{ __html: sessionStatusChangeEvent?.errorMessage }} />
        </div>
      )}
    <NextPrevComponent
      lastPage={sessionStatusChangeEvent?.errorMessage !== "" ? true : false}
      firstPage={true}
      nextClick={handleSubmit}
      nextDisabled={!sessionStatusChangeEvent?.isSelected}
      lblNext={lblBtnSubmit}
      lblCancel={btnCancel}
      lblPrevious={btnCancel}
      showButtons={true}
      hideCancel={false}
    />
  </>);
};
export default StatusChangeEvent;
